import React from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import ViberButton from "@/components/site/ViberButton";

export default function FloatingRFQ() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      <Link to="/contact" aria-label="Direct RFQ Access"
        className="group flex items-center bg-[#E4001C] text-white shadow-2xl shadow-red-900/40 rounded-full h-14 pl-4 pr-4 hover:pr-6 transition-all duration-300 animate-pulse hover:animate-none">
        <FileText className="w-6 h-6 shrink-0" />
        <span className="max-w-0 group-hover:max-w-[180px] overflow-hidden whitespace-nowrap transition-all duration-300 font-tech font-semibold uppercase tracking-widest text-sm group-hover:ml-3">
          Direct RFQ Access
        </span>
      </Link>
      <ViberButton />
    </div>
  );
}